import React from 'react';
export default class TimeLineItem extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    let width = this.props.last ? "small-1 " : "small-2 ";
    let active = ((this.props.active == this.props.item.year) ? "active" : "");
    return (
      <li className={ "timeline__step done " + width + active} onClick={this.props.handleClick.bind(this.props.main, this.props.item)}>
          <label className="timeline__step-label">
              <span className="timeline__step-content">{this.props.item.fecha}</span>
          </label>
          <span className="timeline__step-title">{this.props.item.year}</span>
          <i className="timeline__step-marker pulse-button ">1</i>
      </li>
    )
  }
};



/** WEBPACK FOOTER **
 ** ./client/TimeLineItem.js
 **/